export const getCloudinaryThemeFileUrl = (file: string, fileType: 'image' | 'raw' = 'image') => {
  return `https://res.cloudinary.com/${process.env.NEXT_PUBLIC_CLOUDINARY_THEME_CLOUD_NAME}/${fileType}/upload/themes/${process.env.NEXT_PUBLIC_THEME}/${file}`
}
